var _path, _g, _path2, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZiczac(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 56,
    viewBox: "0 0 1440 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V56H0V0Z",
    fill: "url(#paint0_linear_249_3960)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_249_3960)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 56,
    fill: "url(#paint1_linear_249_3960)",
    fillOpacity: 0.4
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_249_3960",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1440,
    height: 56
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1440V56H0V0Z",
    fill: "url(#paint2_linear_249_3960)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_249_3960)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M616.58 0.6L642.189 21.1231L666.32 0.6L692.421 21.1231L718.523 0.6L743.639 21.1231L770.233 0.6L795.349 21.1231L822.435 0.6L848.044 21.1231L872.175 0.6L898.276 21.1231L924.378 0.6L949.494 21.1231L976.088 0.6L1001.2 21.1231L1028.29 0.6L1053.9 21.1231L1078.03 0.6L1104.13 21.1231L1130.23 0.6L1155.35 21.1231L1181.94 0.6L1207.06 21.1231L1234.14 0.6L1259.75 21.1231L1283.89 0.6L1309.99 21.1231L1336.09 0.6L1361.2 21.1231L1387.8 0.6L1412.91 21.1231L1440 0.6M0 0.6L25.6088 21.1231L49.7401 0.6L75.8413 21.1231L101.943 0.6L127.059 21.1231L153.653 0.6L178.769 21.1231L205.855 0.6L231.464 21.1231L255.595 0.6L281.696 21.1231L307.798 0.6L332.914 21.1231L359.508 0.6L384.624 21.1231L411.71 0.6L437.319 21.1231L461.45 0.6L487.551 21.1231L513.653 0.6L538.769 21.1231L565.363 0.6L590.479 21.1231L617.565 0.6",
    stroke: "#D24CB0",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.58 -11L642.189 9.52308L666.32 -11L692.421 9.52308L718.523 -11L743.639 9.52308L770.233 -11L795.349 9.52308L822.435 -11L848.044 9.52308L872.175 -11L898.276 9.52308L924.378 -11L949.494 9.52308L976.088 -11L1001.2 9.52308L1028.29 -11L1053.9 9.52308L1078.03 -11L1104.13 9.52308L1130.23 -11L1155.35 9.52308L1181.94 -11L1207.06 9.52308L1234.14 -11L1259.75 9.52308L1283.89 -11L1309.99 9.52308L1336.09 -11L1361.2 9.52308L1387.8 -11L1412.91 9.52308L1440 -11M0 -11L25.6088 9.52308L49.7401 -11L75.8413 9.52308L101.943 -11L127.059 9.52308L153.653 -11L178.769 9.52308L205.855 -11L231.464 9.52308L255.595 -11L281.696 9.52308L307.798 -11L332.914 9.52308L359.508 -11L384.624 9.52308L411.71 -11L437.319 9.52308L461.45 -11L487.551 9.52308L513.653 -11L538.769 9.52308L565.363 -11L590.479 9.52308L617.565 -11",
    stroke: "#D24CB0",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.58 12.2L642.189 32.7231L666.32 12.2L692.421 32.7231L718.523 12.2L743.639 32.7231L770.233 12.2L795.349 32.7231L822.435 12.2L848.044 32.7231L872.175 12.2L898.276 32.7231L924.378 12.2L949.494 32.7231L976.088 12.2L1001.2 32.7231L1028.29 12.2L1053.9 32.7231L1078.03 12.2L1104.13 32.7231L1130.23 12.2L1155.35 32.7231L1181.94 12.2L1207.06 32.7231L1234.14 12.2L1259.75 32.7231L1283.89 12.2L1309.99 32.7231L1336.09 12.2L1361.2 32.7231L1387.8 12.2L1412.91 32.7231L1440 12.2M0 12.2L25.6088 32.7231L49.7401 12.2L75.8413 32.7231L101.943 12.2L127.059 32.7231L153.653 12.2L178.769 32.7231L205.855 12.2L231.464 32.7231L255.595 12.2L281.696 32.7231L307.798 12.2L332.914 32.7231L359.508 12.2L384.624 32.7231L411.71 12.2L437.319 32.7231L461.45 12.2L487.551 32.7231L513.653 12.2L538.769 32.7231L565.363 12.2L590.479 32.7231L617.565 12.2",
    stroke: "#D24CB0",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.58 23.8L642.189 44.3231L666.32 23.8L692.421 44.3231L718.523 23.8L743.639 44.3231L770.233 23.8L795.349 44.3231L822.435 23.8L848.044 44.3231L872.175 23.8L898.276 44.3231L924.378 23.8L949.494 44.3231L976.088 23.8L1001.2 44.3231L1028.29 23.8L1053.9 44.3231L1078.03 23.8L1104.13 44.3231L1130.23 23.8L1155.35 44.3231L1181.94 23.8L1207.06 44.3231L1234.14 23.8L1259.75 44.3231L1283.89 23.8L1309.99 44.3231L1336.09 23.8L1361.2 44.3231L1387.8 23.8L1412.91 44.3231L1440 23.8M0 23.8L25.6088 44.3231L49.7401 23.8L75.8413 44.3231L101.943 23.8L127.059 44.3231L153.653 23.8L178.769 44.3231L205.855 23.8L231.464 44.3231L255.595 23.8L281.696 44.3231L307.798 23.8L332.914 44.3231L359.508 23.8L384.624 44.3231L411.71 23.8L437.319 44.3231L461.45 23.8L487.551 44.3231L513.653 23.8L538.769 44.3231L565.363 23.8L590.479 44.3231L617.565 23.8",
    stroke: "#D24CB0",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.58 35.4L642.189 55.9231L666.32 35.4L692.421 55.9231L718.523 35.4L743.639 55.9231L770.233 35.4L795.349 55.9231L822.435 35.4L848.044 55.9231L872.175 35.4L898.276 55.9231L924.378 35.4L949.494 55.9231L976.088 35.4L1001.2 55.9231L1028.29 35.4L1053.9 55.9231L1078.03 35.4L1104.13 55.9231L1130.23 35.4L1155.35 55.9231L1181.94 35.4L1207.06 55.9231L1234.14 35.4L1259.75 55.9231L1283.89 35.4L1309.99 55.9231L1336.09 35.4L1361.2 55.9231L1387.8 35.4L1412.91 55.9231L1440 35.4M0 35.4L25.6088 55.9231L49.7401 35.4L75.8413 55.9231L101.943 35.4L127.059 55.9231L153.653 35.4L178.769 55.9231L205.855 35.4L231.464 55.9231L255.595 35.4L281.696 55.9231L307.798 35.4L332.914 55.9231L359.508 35.4L384.624 55.9231L411.71 35.4L437.319 55.9231L461.45 35.4L487.551 55.9231L513.653 35.4L538.769 55.9231L565.363 35.4L590.479 55.9231L617.565 35.4",
    stroke: "#D24CB0",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.58 47L642.189 67.5231L666.32 47L692.421 67.5231L718.523 47L743.639 67.5231L770.233 47L795.349 67.5231L822.435 47L848.044 67.5231L872.175 47L898.276 67.5231L924.378 47L949.494 67.5231L976.088 47L1001.2 67.5231L1028.29 47L1053.9 67.5231L1078.03 47L1104.13 67.5231L1130.23 47L1155.35 67.5231L1181.94 47L1207.06 67.5231L1234.14 47L1259.75 67.5231L1283.89 47L1309.99 67.5231L1336.09 47L1361.2 67.5231L1387.8 47L1412.91 67.5231L1440 47M0 47L25.6088 67.5231L49.7401 47L75.8413 67.5231L101.943 47L127.059 67.5231L153.653 47L178.769 67.5231L205.855 47L231.464 67.5231L255.595 47L281.696 67.5231L307.798 47L332.914 67.5231L359.508 47L384.624 67.5231L411.71 47L437.319 67.5231L461.45 47L487.551 67.5231L513.653 47L538.769 67.5231L565.363 47L590.479 67.5231L617.565 47",
    stroke: "#D24CB0",
    strokeOpacity: 0.5,
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_249_3960",
    x: -50,
    y: -50,
    width: 1540,
    height: 156,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_249_3960"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_249_3960",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_249_3960",
    x1: -1093.5,
    y1: -64.1846,
    x2: 2400.57,
    y2: -154.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9000E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467584,
    stopColor: "#DC2376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B30AA",
    stopOpacity: 0.77
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_249_3960",
    x1: 17.4395,
    y1: 1.45665,
    x2: 40.4011,
    y2: 210.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9C9C9",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4C4C4",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_249_3960",
    x1: -1093.5,
    y1: -64.1846,
    x2: 2400.57,
    y2: -154.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9000E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467584,
    stopColor: "#DC2376"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B30AA",
    stopOpacity: 0.77
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZiczac);
export default __webpack_public_path__ + "static/media/ziczac.db358a43223c79be36b34fffd0c4e273.svg";
export { ForwardRef as ReactComponent };